const Datastore = require('nedb')

let diagnostics = new Datastore({ filename: "./diagnostics.db", autoload: true });

export default diagnostics;


// WEBPACK FOOTER //
// ./src/services/diagnostics/index.js